// ============================================
// ОПРЕДЕЛЕНИЕ ГЕОЛОКАЦИИ ПО IP
// ============================================
// Автоматическое определение страны по IP адресу и установка региона

(function() {
  'use strict';

  // Флаг, чтобы не определять геолокацию повторно, если пользователь уже выбрал регион вручную
  // Используем то же имя куки, что и в regionSelector.js (cambridge_region)
  const GEO_DETECTED_COOKIE_NAME = 'geoDetected';
  const GEO_CONFIRMED_COOKIE_NAME = 'geoConfirmed';
  const COOKIE_DAYS = 365;
  
  // Переменная для хранения определенного региона
  let detectedCountry = null;

  // Проверяем, не выбрал ли пользователь регион вручную
  function getUserSelectedRegion() {
    // Используем то же имя куки, что и в regionSelector.js
    const regionCookieName = (typeof window.COOKIE_NAME !== 'undefined') 
      ? window.COOKIE_NAME 
      : 'cambridge_region';
    
    
    let cookieValue = null;
    if (typeof window.getCookie === 'function') {
      cookieValue = window.getCookie(regionCookieName);
    } else {
      // Fallback на localStorage
      try {
        cookieValue = localStorage.getItem(regionCookieName);
      } catch (e) {
        console.error('getUserSelectedRegion: ошибка при чтении localStorage:', e);
        return null;
      }
    }
    
    // Если значение есть, пытаемся распарсить JSON
    if (cookieValue) {
      try {
        const parsed = JSON.parse(cookieValue);
        // Возвращаем объект с регионом, если это объект
        if (parsed && typeof parsed === 'object' && parsed.name) {
          return parsed;
        }
        return cookieValue;
      } catch (e) {
        return cookieValue;
      }
    }
    
    return null;
  }

  // Проверяем, было ли уже выполнено определение геолокации
  function wasGeoDetected() {
    if (typeof window.getCookie === 'function') {
      return window.getCookie(GEO_DETECTED_COOKIE_NAME) === 'true';
    }
    try {
      return localStorage.getItem(GEO_DETECTED_COOKIE_NAME) === 'true';
    } catch (e) {
      return false;
    }
  }

  // Проверяем, подтвердил ли пользователь геолокацию
  function wasGeoConfirmed() {
    if (typeof window.getCookie === 'function') {
      return window.getCookie(GEO_CONFIRMED_COOKIE_NAME) === 'true';
    }
    try {
      return localStorage.getItem(GEO_CONFIRMED_COOKIE_NAME) === 'true';
    } catch (e) {
      return false;
    }
  }

  // Сохраняем флаг, что геолокация была определена
  function setGeoDetected() {
    if (typeof window.setCookie === 'function') {
      window.setCookie(GEO_DETECTED_COOKIE_NAME, 'true', COOKIE_DAYS);
    } else {
      try {
        localStorage.setItem(GEO_DETECTED_COOKIE_NAME, 'true');
      } catch (e) {
        console.error('Не удалось сохранить флаг определения геолокации:', e);
      }
    }
  }

  // Сохраняем флаг, что пользователь подтвердил геолокацию
  function setGeoConfirmed() {
    if (typeof window.setCookie === 'function') {
      window.setCookie(GEO_CONFIRMED_COOKIE_NAME, 'true', COOKIE_DAYS);
    } else {
      try {
        localStorage.setItem(GEO_CONFIRMED_COOKIE_NAME, 'true');
      } catch (e) {
        console.error('Не удалось сохранить флаг подтверждения геолокации:', e);
      }
    }
  }

  // Экспортируем функцию setGeoConfirmed глобально, чтобы её можно было вызвать из других модулей
  window.setGeoConfirmed = setGeoConfirmed;

  // Устанавливаем регион
  function setRegion(country, shouldOpenModal = false) {
    const curCountryEl = document.getElementById('curCountry');
    if (!curCountryEl) {
      console.warn('Элемент #curCountry не найден');
      return;
    }

    // Сохраняем определенный регион
    detectedCountry = country;

    // Если нужно открыть модальное окно выбора региона (при первом заходе)
    if (shouldOpenModal && !wasGeoConfirmed()) {
      // Открываем модальное окно выбора региона
      openRegionModal();
      setGeoDetected();
      return;
    }

    // Определяем флаг в зависимости от страны
    const flag = country === 'Узбекистан' ? landingAssetPath('/landing_2025/src/icon/uzb.webp') : landingAssetPath('/landing_2025/src/icon/rf.webp');

    // Вызываем функцию обновления региона, если она доступна
    // updateRegion принимает объект { name, flag }
    if (typeof window.updateRegion === 'function') {
      window.updateRegion({ name: country, flag: flag });
    } else {
      // Fallback: обновляем текст напрямую
      curCountryEl.textContent = country;
    }

    // Вызываем функцию применения региона, если она доступна
    if (typeof window.applyRegion === 'function') {
      window.applyRegion(country);
    }

  }

  // Открываем модальное окно выбора региона
  function openRegionModal() {
    const regionBtn = document.getElementById('regionBtn');
    const regionModal = document.getElementById('regionModal');
    
    
    if (regionModal) {
      // Открываем модальное окно через добавление класса 'open', как в regionSelector.js
      regionModal.classList.add('open');
    } else {
      console.error('regionModal не найден!');
    }
    
    if (regionBtn) {
      // Добавляем класс 'active' к кнопке
      regionBtn.classList.add('active');
    } else {
      console.error('regionBtn не найден!');
    }
  }

  // Определение страны по IP через API
  function detectCountryByIP() {
    // Используем бесплатный API ipapi.co (можно заменить на другой)
    // Альтернативы: ip-api.com, ipgeolocation.io, ip-api.com/json
    const apiUrl = 'https://ipapi.co/json/';

    fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Ошибка при получении данных геолокации');
        }
        return response.json();
      })
      .then(data => {
        // Проверяем код страны
        const countryCode = data.country_code || data.country || '';
        const countryName = data.country_name || '';


        // Если Узбекистан (UZ) - открываем модальное окно выбора региона
        if (countryCode === 'UZ' || countryName.toLowerCase().includes('uzbekistan') || countryName.toLowerCase().includes('узбекистан')) {
          setRegion('Узбекистан', true); // true = открыть модальное окно выбора региона
        } else {
          // Для всех остальных стран - открываем модальное окно выбора региона
          setRegion('Россия', true); // true = открыть модальное окно выбора региона
        }
      })
      .catch(error => {
        console.error('Ошибка определения геолокации по IP:', error);
        // В случае ошибки открываем модальное окно выбора региона
        setRegion('Россия', true); // true = открыть модальное окно выбора региона
      });
  }

  // Альтернативный метод через ip-api.com (если ipapi.co не работает)
  function detectCountryByIPAlternative() {
    const apiUrl = 'http://ip-api.com/json/?fields=status,message,country,countryCode';

    fetch(apiUrl)
      .then(response => {
        if (!response.ok) {
          throw new Error('Ошибка при получении данных геолокации');
        }
        return response.json();
      })
      .then(data => {
        if (data.status === 'fail') {
          throw new Error(data.message || 'Ошибка API');
        }

        const countryCode = data.countryCode || '';
        const countryName = data.country || '';

        // Если Узбекистан (UZ) - открываем модальное окно выбора региона
        if (countryCode === 'UZ' || countryName.toLowerCase().includes('uzbekistan') || countryName.toLowerCase().includes('узбекистан')) {
          setRegion('Узбекистан', true); // true = открыть модальное окно выбора региона
        } else {
          // Для всех остальных стран - открываем модальное окно выбора региона
          setRegion('Россия', true); // true = открыть модальное окно выбора региона
        }
      })
      .catch(error => {
        console.error('Ошибка определения геолокации по IP (альтернативный метод):', error);
        // В случае ошибки открываем модальное окно выбора региона
        setRegion('Россия', true); // true = открыть модальное окно выбора региона
      });
  }

  // Инициализация определения геолокации
  function initGeoLocation() {
    // Не определяем гео, если URL уже указывает на Узбекистан (en-uz/ru-uz)
    const pathMatch = window.location.pathname.match(/^\/([a-z]{2})-([a-z]{2})(\/.*)?$/);
    if (pathMatch && pathMatch[2] === 'uz') {
      return;
    }
    
    // Проверяем, не выбрал ли пользователь регион вручную
    const userSelectedRegion = getUserSelectedRegion();
    
    if (userSelectedRegion) {
      // Проверяем, что это валидный регион (объект с name или строка)
      const regionName = (typeof userSelectedRegion === 'object' && userSelectedRegion.name) 
        ? userSelectedRegion.name 
        : userSelectedRegion;
      
      
      if (regionName && (regionName === 'Россия' || regionName === 'Узбекистан' || regionName === 'Russia' || regionName === 'Uzbekistan')) {
        if (!wasGeoConfirmed()) {
          setGeoConfirmed();
        } else {
        }
        return;
      } else {
      }
    } else {
    }

    // Проверяем, было ли уже выполнено определение и подтверждение
    if (wasGeoDetected() && wasGeoConfirmed()) {
      return;
    }
    
    // Если геолокация была определена, но регион не выбран вручную и не подтвержден
    // открываем модальное окно выбора региона
    if (wasGeoDetected() && !wasGeoConfirmed()) {
      openRegionModal();
      return;
    }

    // Проверяем, что элемент существует
    const curCountryEl = document.getElementById('curCountry');
    if (!curCountryEl) {
      console.warn('Элемент #curCountry не найден, определение геолокации отложено');
      // Повторяем попытку через небольшую задержку
      setTimeout(initGeoLocation, 500);
      return;
    }

    detectCountryByIP();
  }

  // Инициализация при загрузке DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // Небольшая задержка, чтобы другие скрипты успели загрузиться
      setTimeout(initGeoLocation, 1000);
    });
  } else {
    // Если DOM уже загружен
    setTimeout(initGeoLocation, 1000);
  }

  // Экспортируем функцию для ручного вызова (если нужно)
  window.detectGeoLocation = function() {
    initGeoLocation();
  };
})();
